<div #container class="container">
  <a class="expand-btn" (click)="toggleExpand()">
    <div class="inline-icon arrow" inlineSVG="shop-icons.svg#ya-expand_less"
      [ngClass]="expanded ? 'not-expand' : 'expand'">
    </div>
  </a>
  <ng-container *ngIf="!inHouseIsGroup; then inHouseTemplate else groupOrderTemplate"></ng-container>
  <ng-template #inHouseTemplate>
    <div #infocontainer class="info-container" (click)="navigateToTable()">
      <span langkey="phInHouseService_Button_Text" class="text"></span>
      <span class="text">{{tableNumberText}}</span>
      <div class="icon">
        <div id="header-icon-basket" class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-tisch-voll"></div>
      </div>
      <ng-container *ngIf="!mandatoryPayment">
        <div class="basket">
          <span class="text">{{openItemsText}}</span>
          <span class="text">{{priceFormatter(open_price)}}</span>
        </div>
      </ng-container>
    </div>
  </ng-template>
  <ng-template #groupOrderTemplate>
    <div #infocontainer class="info-container" (click)="navigateToGroupOrder()">
      <span langkey="phGroupOrder_Button_Text" class="text"></span>
      <span class="text">{{groupName}}</span>
      <div class="icon">
        <div id="header-icon-basket" class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-multi"></div>
      </div>
      <div class="basket">
        <span class="text">{{openItemsText}}</span>
        <span class="text">{{priceFormatter(open_price)}}</span>
      </div>
    </div>
  </ng-template>
</div>